import type * as core from '../../../../../../../core'

export const query: core.mosaic.Action.Query = {
  selection: {
    '{}': {
      payload: {
        '[]': [
          {
            '{}': {
              insertion: {
                '{}': {
                  inputs: {
                    '{}': {
                      records: {
                        '[]': [
                          {
                            '{}': {
                              values: {
                                '{}': {
                                  '!code': {
                                    '@$': 'code',
                                  },
                                  '!name': {
                                    '@$': 'name',
                                  },
                                  '!type': {
                                    '@$': 'type',
                                  },
                                  '!proposal': {
                                    '{}': {
                                      entityId: 'ent:!proposals:!proposal',
                                      recordId: {
                                        '@$': 'proposalId',
                                      },
                                    },
                                  },
                                  '!personnel': {
                                    '{}': {
                                      entityId: 'ent:!personnel:!employee',
                                      recordId: {
                                        '??': [
                                          {
                                            '@>': [
                                              {
                                                '@$': 'personnelId',
                                              },
                                              'recordId',
                                            ],
                                          },
                                          {
                                            '@$': 'personnelId',
                                          },
                                        ],
                                      },
                                    },
                                  },
                                },
                              },
                            },
                          },
                        ],
                      },
                    },
                  },
                  modelId: 'ent:!proposal_personnel:!entry',
                },
              },
            },
          },
        ],
      },
      operation: 'dms.mutate',
    },
  },
}
